import { render } from "./OurNews.vue?vue&type=template&id=64912a64&scoped=true"
import script from "./OurNews.vue?vue&type=script&lang=js"
export * from "./OurNews.vue?vue&type=script&lang=js"

import "./OurNews.vue?vue&type=style&index=0&id=64912a64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64912a64"]])

export default __exports__